import { ColumnDef, createColumnHelper } from '@tanstack/react-table';
import { SyntheticEvent } from 'react';
import { useTranslation } from 'react-i18next';

import { Table } from '@components/Table';

import { accountingLocationName } from '@utils/accountingLocationHelper';
import { formatTimestamp } from '@utils/dateTimeFormatter';

import { TaskData } from '@api/generator';

import { filterTask } from '@service/taskManagement';

import styles from '../taskManagement.module.scss';

interface TaskDataProps {
  onRowClick: (selectedTask: TaskData) => (e: SyntheticEvent) => void;
  data: TaskData[];
}

const getClassName = (status: string) => {
  if (!status) return '';
  status = status.toLowerCase();
  switch (status) {
    case 'pending':
      return 'pending';
    case 'due':
      return 'due';
    case 'overdue':
      return 'overDue';
    case 'late':
      return 'late';
    case 'completed':
      return 'completed';
    case 'incomplete':
      return 'incomplete';
    default:
      return 'statusDefault';
  }
};

const languageNamespace = 'task-management';

const columnHelper = createColumnHelper<TaskData>();
export const TasksData = ({ data, onRowClick }: TaskDataProps) => {
  const { t } = useTranslation(languageNamespace);
  const records = filterTask('task', data);
  const columns = [
    columnHelper.accessor('task', {
      header: t('task'),
      cell: (info) => {
        return (
          <div className={styles.divTaskListContainer}>
            <button
              data-testid={`taskButton-${info?.row?.index}`}
              onClick={onRowClick(info?.row?.original)}
              className={styles.taskButton}
              data-cy="cashLink">
              {info.getValue() +
                ' | ' +
                accountingLocationName(info?.row?.original?.accountingLocationName)}
            </button>
          </div>
        );
      },
    }),
    columnHelper.accessor('runDateTime', {
      header: t('dueDate'),
      cell: (info) => formatTimestamp(info.getValue(), 'date'),
    }),
    columnHelper.accessor('status', {
      header: t('status'),
      cell: (info) => (
        <div className={styles[getClassName(info.getValue())]}>{info.getValue()}</div>
      ),
    }),
  ] as ColumnDef<unknown, unknown>[];

  return (
    <Table
      columns={columns}
      data={records}
      showFooter={false}
      headerClassName={styles.headerTitle}
      isPaginated={false}
      tableClassName={styles.taskTable}
    />
  );
};
